module.exports = __webpack_public_path__ + "static/3295f17f-698f-4c6c-a651-f83f9722ed7d-c8af527594cc42a4a7c33f20c05e1989.webp";